import { render } from "./BaselineFormPopup.vue?vue&type=template&id=40fb0484&scoped=true&ts=true"
import script from "./BaselineFormPopup.vue?vue&type=script&lang=ts"
export * from "./BaselineFormPopup.vue?vue&type=script&lang=ts"

import "./BaselineFormPopup.vue?vue&type=style&index=0&id=40fb0484&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fb0484"]])

export default __exports__